


































import { Component, Vue } from 'vue-property-decorator'
import { approvalTrace } from '@/apis/sheet'
import uploadList from '@/views/sheet/components/uploadList.vue'
@Component({
  name: 'Log',
  components: {
    uploadList
  }
})
export default class extends Vue {
  private approvalOperator = {
    begin: {
      icon: 'iconPlus',
      color: '#1A8CFF'
    },
    success: {
      icon: 'iconcheck',
      color: '#58CC1F'
    },
    failure: {
      icon: 'iconguanbi',
      color: '#F23030'
    },
    over: {
      icon: 'iconfont iconjieshu',
      color: '#8C8C8C'
    },
    rollback: {
      icon: 'iconfont iconshenhetuihui',
      color: '#F5BC00'
    }
  }
  private list = [] as any []
  private loading = false
  private finished = false
  private page = { pageNumber: 0, pageSize: 10, total: 0 }
  private onLoad () {
    this.getFetchData(false)
  }
  private async getFetchData (isStart) {
    const pageNum = this.page.pageNumber + 1
    let {processId} = this.$route.params
    const data = {
      processId,
      pageNum,
      pageSize: this.page.pageSize
    }
    let res = await approvalTrace(data)
    if (res.success) {
      this.loading = false
      this.page.pageNumber = pageNum
      this.page.total = res.data.total
      if (isStart || pageNum === 1) {
        this.list = res.data.list || []
      } else {
        this.list = this.list.concat(res.data.list)
      }
      this.finished =  this.list.length >= this.page.total
    } else {
      this.loading = false
      this.finished = true
    }
  }
  private mounted () {
    this.getFetchData(true)
  }
}
